import classNames from 'classnames'
import React from 'react'
import { getAmount } from '../../../utils/getAmount'
import styles from './CargoSideModal.module.css'

type UnpaidCargosHeaderProps = {
  checkboxId: string
  selectAll: boolean
  onSelectAll: () => void
  disabled?: boolean
  totalAmount: number
  currency: string
}

const UnpaidCargosHeader: React.FC<UnpaidCargosHeaderProps> = ({
  checkboxId,
  selectAll,
  onSelectAll,
  disabled,
  totalAmount,
  currency,
}) => {
  return (
    <div className={classNames(styles.bgWhite, 'pt-1 pb-1 mb-2')}>
      <div className="row align-items-center ml-2 mr-2 mb-2">
        <div className={classNames(styles.small2, 'col pt-1 pb-1 pl-0')}>
          <input
            type="checkbox"
            id={checkboxId}
            checked={selectAll}
            onChange={onSelectAll}
            disabled={disabled}
          />
          <label htmlFor={checkboxId}>Выбрать все</label>
        </div>
        <div className="col pl-1 pr-0" style={{ textAlign: 'right' }}>
          <div className={classNames(styles.colorGray, styles.small2)}>
            Общая сумма
          </div>
          <b className={styles.nowrap}>
            {getAmount(totalAmount)} {currency}
          </b>
        </div>
      </div>
    </div>
  )
}

export default UnpaidCargosHeader
